import { getErrorss } from '../../../../functions/errors/GetErrors'
import { createDocument } from '../../../../store/actionsCreators/documentsActions/createDocument'
import { uploadMultipleForOffers } from '../../../../store/actionsCreators/documentsActions/upload/uploadMultipleForOffers'
import { uploadSingleFile } from '../../../../store/actionsCreators/documentsActions/upload/uploadSingleFile'
import { type AppDispatch } from '../../../../store/store'
import { type ManualOfferDocumentFiles, type ManualOfferDocumentType, type ManualOfferDocumentUploadResult, type ManualOfferListingType } from './manualOperations.types'

export const getManualOfferSignedDocumentCategory = (listingType: ManualOfferListingType): string =>
    listingType === 'Rent' ? 'Tenancy Contract' : 'Booking Form'

export const uploadManualOfferRentDepositSlip = ({
    file,
    offerId
}: {
    file: File
    offerId: number
}) => async (): Promise<{ isSuccessful: boolean, url?: string, error?: string }> => {
    const url = await uploadSingleFile(file, undefined, 'offers', String(offerId))
    return url != null
        ? { isSuccessful: true, url }
        : { isSuccessful: false, error: 'Could not upload deposit slip.' }
}

export const uploadManualOfferRelatedDocuments = ({
    offerId,
    documentType,
    documents
}: {
    offerId: number
    documentType: ManualOfferDocumentType
    documents: ManualOfferDocumentFiles
}) => async (dispatch: AppDispatch): Promise<ManualOfferDocumentUploadResult> => {
    const formValues: Record<string, any> = {
        offerID: offerId
    }

    if ((documentType === 'passport' || documentType === 'both') && documents.passport != null) {
        formValues.visa = [documents.passport]
    }
    if ((documentType === 'emirates-id' || documentType === 'both') && documents.emiratesIdFront != null) {
        formValues.id_front = [documents.emiratesIdFront]
    }
    if ((documentType === 'emirates-id' || documentType === 'both') && documents.emiratesIdBack != null) {
        formValues.id_back = [documents.emiratesIdBack]
    }
    if (documents.tradeLicense != null) {
        formValues.trade_licence = [documents.tradeLicense]
    }
    if (documents.depositCheque != null) {
        formValues.cheque_copy = [documents.depositCheque]
    }

    const documentIds = await dispatch(uploadMultipleForOffers(formValues, 'agent_to_bso_offer'))
    if (Array.isArray(documentIds)) {
        return { isSuccessful: true, ids: documentIds.filter((id): id is number => Number.isFinite(Number(id))).map(Number) }
    }

    return { isSuccessful: false, error: documentIds?.textNotification ?? 'Could not upload offer documents.' }
}

export const uploadManualOfferSignedDocument = ({
    file,
    offerId,
    unitId,
    listingType
}: {
    file: File
    offerId: number
    unitId: number
    listingType: ManualOfferListingType
}) => async (dispatch: AppDispatch): Promise<ManualOfferDocumentUploadResult> => {
    const category = getManualOfferSignedDocumentCategory(listingType)
    const response = await dispatch(createDocument([file], {
        RefID: `REF_DOC_${category.toLowerCase().replaceAll(' ', '_')}_${Date.now()}`,
        Category: category,
        Statuses: listingType === 'Sale' ? ['Approved'] : ['In-process'],
        Offer: offerId,
        Unit: unitId
    }, 'offers', String(offerId)))
    const responseData = response as any
    const id = Number(responseData?.response?.data?.id ?? responseData?.data?.id)
    return response?.isSuccessful === true && Number.isFinite(id)
        ? { isSuccessful: true, id }
        : { isSuccessful: false, error: response?.textNotification ?? getErrorss(response) }
}
